module.exports = __webpack_public_path__ + "img/trennwand.d17a35a1.webp";